import React from 'react'
import {IUser, SigninRedirectCallbackReturn} from '../types/AuthTypes'

export interface IAuthContext {
  getUser: () => Promise<IUser | null>;
  isAuthenticated: () => Promise<boolean>;
  signinSilent: () => Promise<void>;
  signinRedirect: (returnUrl?: (string | undefined)) => Promise<void>;
  signinRedirectCallback: () => Promise<SigninRedirectCallbackReturn | null>;
  signinSilentCallback: () => Promise<IUser | null>;
  createSigninRequest: () => Promise<void>;
  logout: () => Promise<void>;
  signoutRedirectCallback: () => Promise<void>;
}

const defaultAuthContext: IAuthContext = {
  getUser: () : Promise<IUser | null> => Promise.resolve(null),
  isAuthenticated: () : Promise<boolean> => Promise.resolve(false),
  signinSilent: () => Promise.resolve(),
  signinRedirect: () => Promise.resolve(),
  signinRedirectCallback: () : Promise<SigninRedirectCallbackReturn | null> => Promise.resolve(null),
  signinSilentCallback: () : Promise<IUser | null> => Promise.resolve(null),
  createSigninRequest: () => Promise.resolve(),
  logout: () => Promise.resolve(),
  signoutRedirectCallback: () => Promise.resolve(),
}

export const AuthContext = React.createContext(defaultAuthContext)
